import React from 'react'

import s from './styles.module.scss'

import { SeasonEnum } from '../../../../../../../../../lib/graphql'

const PriceSeasonColorDot = ({
  season,
  style = {},
}: {
  season: SeasonEnum
  style?: React.CSSProperties
}) => {
  const seasonColors = {
    [SeasonEnum.HIGH]: '#ff0000',
    [SeasonEnum.MEDIUM]: '#f1960d',
    [SeasonEnum.LOW]: '#0cbc8b',
    YELLOW: 'rgba(255, 245, 0, 1)',
  }

  return (
    <div
      className={s.seasonColorDot}
      style={{ ...style, backgroundColor: seasonColors[season] }}
    />
  )
}

export default PriceSeasonColorDot
